import { api } from './index';

const BASE_PATH = '/api/internal/patient_service_categories';

export type PatientServiceSubcategory = {
  id: number;
  name: string;
  discarded: boolean;
};

export type PatientServiceCategory = {
  id: number;
  name: string;
  priority: number;
  prioritizationEnabled: boolean;
  discardedAt?: string;
  discarded: boolean;
  humanCreatedAt: string;
  humanDiscardedAt?: string;
  patientServiceSubcategories: PatientServiceSubcategory[];
};

// Slim shape returned by ?for_filters=true (kept records only, priority desc).
export type PatientServiceCategoryFilter = {
  id: number;
  name: string;
  priority: number;
  subcategories: Array<{ id: number; name: string }>;
};

export interface PatientServiceSubcategoryForm {
  id?: number;
  name: string;
  _destroy?: boolean;
}

export interface PatientServiceCategoryForm {
  id?: number;
  name: string;
  priority: number;
  prioritizationEnabled: boolean;
  patientServiceSubcategoriesAttributes?: PatientServiceSubcategoryForm[];
}

export const patientServiceCategoriesApi = {
  index(scope?: 'active' | 'discarded'): Promise<Array<PatientServiceCategory>> {
    const params = scope === 'discarded' ? { scope: 'discarded' } : {};

    return api({
      method: 'get',
      url: BASE_PATH,
      params,
    }).then(response => response.data.patientServiceCategories);
  },
  indexForFilters(): Promise<Array<PatientServiceCategoryFilter>> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?for_filters=true`,
    }).then(response => response.data.patientServiceCategories);
  },
  create(categoryForm: PatientServiceCategoryForm): Promise<PatientServiceCategory> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { patientServiceCategory: categoryForm },
    }).then(response => response.data.patientServiceCategory);
  },
  update(categoryForm: Partial<PatientServiceCategoryForm>): Promise<PatientServiceCategory> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${categoryForm.id}`,
      data: { patientServiceCategory: categoryForm },
    }).then(response => response.data.patientServiceCategory);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    });
  },
};
